/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { meetingDataTypeSchema } from './MeetingDataTypeSchema'

export const meetingDataSchema = z.object({
	type: meetingDataTypeSchema,
	startsAt: z.iso.datetime(),
	endsAt: z.iso.datetime(),
	joinableAt: z.iso.datetime(),
	expiresAt: z.iso.datetime(),
	duration: z.number(),
	locationDetails: z.string().nullable(),
	candidateLink: z.string().nullable(),
	recruiterLink: z.string().nullable(),
})

export type MeetingDataSchema = z.infer<typeof meetingDataSchema>
